/**
 * Created by mykurisu on 2017/10/10.
 * 2019/1/7 增加后台可配置icon功能
 * is_promote_flag: cps过来的参数，如果有这个参数，只显示一个icon，即个人中心
 */
import React from 'react'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import '../../css/wkCommon.css'
import axios from 'axios'

const ifError = {
    type: 'normal',
    icons: [
        {
            normal: 'https://static-1253442168.file.myqcloud.com/xupload/20190408_tabbar-fx.png',
            active: 'https://static-1253442168.file.myqcloud.com/xupload/20190408_tabbar-fx-active.png'
        }, {
            normal: 'https://static-1253442168.file.myqcloud.com/xupload/20190408_tabbar-my.png',
            active: 'https://static-1253442168.file.myqcloud.com/xupload/20190408_tabbar-my-active.png'
        }, {
            normal: 'https://static-1253442168.file.myqcloud.com/xupload/20190408_tabbar-account.png',
            active: 'https://static-1253442168.file.myqcloud.com/xupload/20190408_tabbar-account-active.png'
        }
    ]
}

class WKBottomNav extends React.Component {
    constructor() {
        super()
        this.state = {
            icons: [],
            type: '',
            init: false
        },
        this.is_promote_flag = browserHistory.getCurrentLocation().query.is_promote_flag ? true : false // 如果有这个参数隐藏一些icon
    }

    async componentDidMount() {
        try {
            const res = await axios.get('/operating/api/index/get_icons')
            if (res.data.code === 0) {
                this.setState({...res.data.data, init: true})
            } else {
                this.setState({...ifError, init: true})
            }
        } catch (err) {
            this.setState({...ifError, init: true})
        }
    }

    linkTo(val) {
        if (window.location.host.indexOf('dbg') > -1) {
            // dbg env
            if (val === '/') {
                window.location.assign('http://dbg.lizhiweike.com/2homepage/')
            } else {
                window.location.assign(val)
            }
        } else {
            window.location.assign(val)
        }
    }

    render() {
        const pathname = window.location.pathname;
        if (!this.state.init) {
            return null
        }
        const {icons} = this.state
            return (
                <div className="wk-bottom-nav" style={{overflow: this.state.type === "special" && 'unset'}}>
                    {!this.is_promote_flag &&
                        <div className={`nav-item ${this.state.type === "special" ? "ifSpecialIcon": ""}`}
                             onClick={() => this.linkTo('/')}>
                        <img src={pathname === '/' ? icons[0].active : icons[0].normal } alt="" />
                    </div>}

                    {!this.is_promote_flag &&
                        <div className={`nav-item ${this.state.type === "special" ? "ifSpecialIcon": ""}`}
                             onClick={() => this.linkTo('/specials/mywk')}>
                        <img src={['/mywk', '/specials/mywk'].indexOf(pathname) > -1 ? icons[1].active : icons[1].normal} alt=""/>
                    </div>}

                    <div className={`nav-item ${this.state.type === "special"? "ifSpecialIcon": ""}`} style={{width: this.is_promote_flag && '100%'}}
                         onClick={() => this.linkTo('/account/')}>
                        <img src={pathname === '/account/' ? icons[2].active : icons[2].normal} alt="" />
                    </div>
                </div>
            )
        }
}

export default connect((state) => ({
    accountId: state.account.id
}))(WKBottomNav)



// WEBPACK FOOTER //
// ./src/components/wk/WKBottomNav.js